import { useUI } from "providers/UIProvider"

import SettingsLayout from "components/shared/layouts/SettingsLayout"

import BookingSettingsForm from "./BookingSettingsForm"

const BookingsSettingsTemplate = () => {
  const { T } = useUI()

  return (
    <SettingsLayout title={T("booking_settings.title")}>
      <BookingSettingsForm />
    </SettingsLayout>
  )
}

export default BookingsSettingsTemplate